import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import BreadCrump from '../tools/breadcrump';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import ImageUploaders from '../tools/uploaderimages';
import { Button, Input, Placeholder, Tabs } from 'rsuite';
import { Select } from '@mui/material';
import QACreator from '../Qa/QaComponent';
import { url } from 'inspector';
import generatePDF, { Resolution, Margin, usePDF } from 'react-to-pdf';

import PriceEditor from './PriceEditor';
import HeaderOfPage from '../tools/headerOfPage';
import { QRCodeCanvas } from 'qrcode.react';

export default function LabelProdcut() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [list, setListArticle] = useState<any>(null);
    const [brands, setBrands] = useState<any>(null);
    const [pricellist, setPriceList] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [feature, setFeature] = useState<any>([]);
    const [keyprice, setKeyprice] = useState<any>(1);

    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/pproducts/${Id}`;
            var x = data;
            console.log(x);
            let res = await axios({
                method: 'put',
                data: x,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('بروزرسانی اطلاعات')
        } catch (error) {

        }
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/pproducts/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message);
            setFeature(res.data.feature);
            //  CreatePriceGroupFirst(res.data.message.id);
        } catch (error) {

        }
    }
    const getalldata = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setListArticle(res.data.message);
        } catch (error) {


        }
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/productprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setPriceList(res.data.message);
        } catch (error) {


        }
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'List Products',
            url: '/dashboard/Products/Products'
        },
        {
            name: 'Edit Product',
            url: null
        },
    ]
    const CreatePriceGroup = async () => {
        try {
            let res = await axios({
                method: 'post',
                data: {
                    name: data.id,
                    model: 'selfprice',
                    url: data.id
                },
                url: config.url + '/v1/dashboard/productprice/selfprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            console.log(res.data.message);
            setData({ ...data, price: res.data.message });
            setKeyprice(keyprice + 1);
        } catch (error) {

        }
    }
    const CreatePriceGroupFirst = async (newid: any) => {
        try {
            let res = await axios({
                method: 'post',
                data: {
                    name: newid,
                    model: 'selfprice',
                    url: newid
                },
                url: config.url + '/v1/dashboard/productprice/selfprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


        } catch (error) {

        }
    }
    const { toPDF, targetRef } = usePDF({
        filename: 'invoice.pdf',
        page: {
            format: [50, 30], // Width x Height in mm
            orientation: 'landscape'
        }
    });
    useEffect(() => {
        getalldata();

        load();
    }, []);
    return (
        <div>
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="چاپ لیبل"></HeaderOfPage>



            {
                data != null && <div className='grid grid-cols-1 sm:grid-cols-5 gap-2'>
                    <button type="button"
                        onClick={() => toPDF({
                            filename: data.id + '.pdf',
                            page: {
                                // Custom size in millimeters (default is A4)
                                //format: [25, 14], // Width x Height in mm (equivalent to A4 landscape)
                                // OR specify exact dimensions:
                                //width: '51mm',
                                // height: '34mm',
                                // Margins
                                // OR specify exact dimensions:
                                format: [30, 50],

                                // Orientation (optional)
                                orientation: 'portrait' // or 'portrait'
                            }
                        })}
                        className="float-end py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-green-500 text-white hover:bg-green-700 yarnfocus:outline-none focus:bg--800 disabled:opacity-50 disabled:pointer-events-none ">
                        <img src="/icons/print.svg" width={10}></img>
                        {t('چاپ')}
                    </button>
                    <div className='col-span-1 sm:col-span-4'>
                        <div className='w-full'>
                            <div ref={targetRef} className='w-[300px]  border-[1px]   h-[180px] p-1 pr-3 border-black relative mx-auto'>

                                <div className={`flex flex-row justify-between`}>

                                    <div style={{ width: '223px', lineHeight: '1.2' }} className={`flex pt-4 flex-col items-end justify-between`}>
                                        <h3 style={{ lineHeight: '1.2', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                                            <p style={{ fontSize: '19px',borderBottom:'solid 1px black' ,paddingBottom:'10px'}}> {data.name}</p>
                                          
                                            <p style={{ color: '#333' }}>کد محصول : {data.alt}</p>
                                            <p style={{ fontSize: '10px' }}><strong>گروه</strong> : <br /> {data.toGroup.name}</p>

                                        </h3>

                                    </div>
                                    <div className={` flex items-center justify-center`}>
                                        <div className={`scale-[0.6] mt-[-20px] `}>
                                            <QRCodeCanvas width={10} value={`https://nanosealco.com/detail/${data.url}`} />


                                        </div>

                                    </div>


                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            }

        </div>
    )
}